import { FunctionComponent } from 'react';
import ConfirmationDialogue from '../../../../Compound/ConfirmationDialogue/ConfirmationDialogue';
import { useTranslation } from 'react-i18next';

type InvalidEndDateDialogueProps = {
  shouldShowEndDateError?: boolean;
  setShouldShowEndDateError?: (e: boolean) => void;
};

type FC = FunctionComponent<InvalidEndDateDialogueProps>;

const InvalidEndDateDialogue: FC = (props) => {
  const { shouldShowEndDateError, setShouldShowEndDateError } = props;
  const { t } = useTranslation('components', { keyPrefix: 'DatePicker.InvalidEndDateDialogue' });

  return (
    <ConfirmationDialogue
      isVisible={shouldShowEndDateError || false}
      title={t('title')}
      status="error"
      width="510px"
      subTitle={t('subTitle')}
      buttonBackgroundColor="#FFD147"
      buttonTextColor="#2D2D2D"
      buttonWidth="120px"
      confirm={{
        label: t('confirmationButton'),
        action: () => {
          setShouldShowEndDateError && setShouldShowEndDateError(false);
        },
      }}
    />
  );
};

export default InvalidEndDateDialogue;
